// Timing constants (in milliseconds)
export const DELAYS = {
  BROWSER_OPEN: 1000,
  STATE_CHANGE: 1000,
  REDIRECT: 2000,
  INACTIVITY_TIMEOUT: 60000,
  CAT_ANIMATION: 2200,
  MAW_STATE_CHANGE: 1000,
  POKE_RECOVERY: 1000,
  LEAVE_ANIMATION: 5000,
  DIALOG_HIDE: 2000,
} as const;

// Audio volume levels (0.0 to 1.0)
export const AUDIO_VOLUMES = {
  CLICK_SOUND: 0.4,
  TYPING_SOUND: 0.4,
  BACKGROUND_MUSIC: 0.1,
  POKE_SOUND: 0.1,
  LOST_SOUND: 0.1,
} as const;

// Responsive breakpoints (in pixels)
export const BREAKPOINTS = {
  MOBILE: 540,
  TABLET: 768,
} as const;

// Animation durations
export const ANIMATION_DURATIONS = {
  MAW_WALK: 5000,
  MAW_ENTRANCE: 1200,
  CAT_WALK_RALPH: 2000,
  CAT_WALK_ATREYU: 2200,
} as const;

// Maximum counts
export const LIMITS = {
  MAX_POKE_COUNT: 4,
} as const;

// Original tracks played by the radio in Avatar. Order is the catalog order;
// playback order is shuffled at runtime.
export const TRACKS: ReadonlyArray<{ src: string; title: string }> = [
  { src: '/sounds/music/Maw - Copy That (v3).mp3',     title: 'Copy That' },
  { src: '/sounds/music/Maw - Escape (v2).mp3',        title: 'Escape' },
  { src: '/sounds/music/Maw - Fuzzy Thoughts.mp3',     title: 'Fuzzy Thoughts' },
  { src: '/sounds/music/Maw - Inhala-Exhala (v4).mp3', title: 'Inhala-Exhala' },
  { src: '/sounds/music/Maw - Mata kondo.mp3',         title: 'Mata kondo' },
  { src: '/sounds/music/Maw - Nullaby (v5).mp3',       title: 'Nullaby' },
  { src: '/sounds/music/Maw - Siete.mp3',              title: 'Siete' },
];
